
import $ from 'jquery';
import filters from '@/filters';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';

import PaginationMiniComponent from '@/components/paginations/PaginationMini.vue';

@Component({
  components: {
    PaginationMiniComponent,
  },
  filters,
})
export default class SuccessStories extends Vue {

  /* VUEX */

  // ACTION
  @Action('actionSelectCandidate', { namespace: 'candidate' }) private actionSelectCandidate: any;
  @Action('actionSelectSuccessStory', { namespace: 'information' }) private actionSelectSuccessStory: any;
  @Action('actionDeleteSuccessStory', { namespace: 'information' }) private actionDeleteSuccessStory: any;
  @Action('actionResetSuccessStory', { namespace: 'information' }) private actionResetSuccessStory: any;
  @Action('actionPaginationSuccessStory', { namespace: 'information' }) private actionPaginationSuccessStory: any;

  // STATE
  @State('array_candidate', { namespace: 'candidate' }) private array_candidate: any;
  @State('success_story', { namespace: 'information' }) private success_story: any;
  @State('array_success_story', { namespace: 'information' }) private array_success_story: any;
  @State('pagination_success_story', { namespace: 'information' }) private pagination_success_story: any;
  @State('school', { namespace: 'academy' }) private school: any;

  /* INITIALIZATION */

  private canDeleting: boolean = false;

  constructor() {
    super();
  }

  /* LIFECILCY */

  private created() {
    this.actionResetSuccessStory();
    this.actionSelectCandidate();
    this.clickSearch();
  }

  /* LISTENER */

  private listenerDelete() {
    this.clickSearch();
  }

  /* METHOD */

  private clickSearch() {
    this.actionSelectSuccessStory({school: this.school, success_story: this.success_story});
  }

  private clickDeleteSelectedSuccessStory() {
    if (this.canDeleting) {
      const items = Array.from($('.ContainerCheckbox > label > input:checked'));
      if (items.length > 0) {
        if (confirm('Are you sure delete this news?')) {
          items.forEach((item: any) => {
            this.actionDeleteSuccessStory({ id: $(item).val(), listener: this.listenerDelete});
          });
        }
      }
    }
  }

  private clickPage(page: number, url: string) {
    if (url) {
      this.actionPaginationSuccessStory({url, page});
    } else {
      this.clickSearch();
    }
  }
}
